module.exports = __webpack_public_path__ + "media/images/icon__point--text@2x-bb77d9bcaf3fb233beacb480f8687e05.png";